import React from 'react';

export default function SVG(props: React.SVGAttributes<SVGElement>) {
    return (
        <svg
            className={props.className + ' Stroke_sc'}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 60"
        >
            <path
                d="M2,7.75 C1.30964406,7.75 0.75,8.30964406 0.75,9 L0.75,34.9586208 C0.75,35.6489767 1.30964406,36.2086208 2,36.2086208 L11.5019806,36.2086208 C12.5388909,36.2086208 13.487646,36.7918684 13.9557748,37.7170918 L21.3290835,52.2899152 C21.5418693,52.7104713 21.9731216,52.9755839 22.4444444,52.9755839 C23.1348004,52.9755839 23.6944444,52.4159398 23.6944444,51.7255839 L23.6944444,9 C23.6944444,8.30964406 23.1348004,7.75 22.4444444,7.75 L2,7.75 Z"
                strokeWidth="1.5"
            ></path>
            <path
                d="M37.5555556,7.75 C36.8651996,7.75 36.3055556,8.30964406 36.3055556,9 L36.3055556,34.9586208 C36.3055556,35.6489767 36.8651996,36.2086208 37.5555556,36.2086208 L47.0575362,36.2086208 C48.0944465,36.2086208 49.0432015,36.7918684 49.5113303,37.7170918 L56.884639,52.2899152 C57.0974248,52.7104713 57.5286771,52.9755839 58,52.9755839 C58.6903559,52.9755839 59.25,52.4159398 59.25,51.7255839 L59.25,9 C59.25,8.30964406 58.6903559,7.75 58,7.75 L37.5555556,7.75 Z"
                strokeWidth="1.5"
            ></path>
        </svg>
    );
}
